export default __webpack_public_path__ + "static/logo-invictus-white-89c190e57fc04624f55e051376fda8e7.webp";